import React from 'react'
import PropTypes from 'prop-types'
import { Box, Pagination, Select, MenuItem, Typography, Stack } from '@mui/material'

const TablePagination = ({
    page,
    perPage,
    total,
    onPageChange,
    onPerPageChange,
    perPageOptions = [5, 10, 25, 50, 100],
}) => {
    // Ensure at least 1 page for MUI Pagination (it doesn't accept count=0)
    const pageCount = Math.max(1, Math.ceil(total / perPage))

    const handlePage = (_, value) => {
        onPageChange(value)
    }

    const handlePerPage = (e) => {
        onPerPageChange(parseInt(e.target.value, 10))
    }

    // Calculate how many items are shown on the current page for a clearer "Showing" label
    const safePage = Math.max(1, page)
    const itemsOnPage = Math.max(0, Math.min(perPage, total - (safePage - 1) * perPage))

    return (
        <Box dir="ltr" sx={{ p: 2 }}>
            <Stack
                direction={{ xs: 'column', sm: 'row' }}
                alignItems="center"
                justifyContent="space-between"
                spacing={2}
            >
                <Typography variant="body2" align="left">
                    Showing {itemsOnPage} of {total} items
                </Typography>

                <Pagination
                    count={pageCount}
                    page={page}
                    onChange={handlePage}
                    siblingCount={1}
                    boundaryCount={1}
                    showFirstButton
                    showLastButton
                    sx={{ '& .MuiPaginationItem-root': { fontSize: '0.9rem' } }}
                    aria-label="table pagination"
                />

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="body2" sx={{ ml: 1 }}>
                        Per page:
                    </Typography>
                    <Select size="small" value={perPage} onChange={handlePerPage} sx={{ minWidth: 64, }}>
                        {perPageOptions.map((opt) => (
                            <MenuItem key={opt} value={opt}>
                                {opt}
                            </MenuItem>
                        ))}
                    </Select>
                </Box>
            </Stack>
        </Box>
    )
}

TablePagination.propTypes = {
    page: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    onPerPageChange: PropTypes.func.isRequired,
    perPageOptions: PropTypes.array,
}

export default TablePagination
